import React from 'react';

const FreshWorks = ({ className = '', title = 'Customer Support' }) => {
  const openWidget = (e) => {
    if (window && window.FreshworksWidget) {
      e.preventDefault();
      window.FreshworksWidget('open');
      return true;
    }
    return false;
  };

  return (
    <a
      href="https://digitalinspiration.freshdesk.com/widgets/feedback_widget/new"
      target="_noblank"
      onClick={openWidget}
      rel="nofollow noreferrer"
      className={className}
    >
      {title}
    </a>
  );
};

export default FreshWorks;
